<template>
  <section class="container">
    <div class="route">
      {{$locales.gestionanticipos.gestionanticipos}} > {{$locales.gestionanticipos.anticipoordenesmarcadas}}
    </div>
    <div class="wide-window">
      <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
        <p>check_circle</p>
        <h3>Operación realizada con éxito</h3>
      </div>
      <div class="mensajeError" v-else-if="confirmacion=='KO'">
        <p>cancel</p>
        <h3>{{mensajeError}}</h3>
      </div>
      <h1>{{$locales.gestionanticipos.anticipoordenesmarcadas}}</h1>
          <div v-if=datosFirmaSim>
            <SignatureComponent :queries="queries" :datosFirma="datosFirmaSim" :llamada="llamada" @aceptar="callBackAceptarSim" @cancelar="callBackCancelarSim"></SignatureComponent>
          </div>
      <div class="form-group">
        <div class="output" v-if="datosSalida">
          <md-table v-model="ordenMarcada">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell><span class="cabeceraVertical">{{ item.label }}</span></md-table-cell>
              <md-table-cell>{{ item.value }} <span v-if="item.moneda">{{ item.moneda }}</span></md-table-cell>
            </md-table-row>
          </md-table>
          <hr/>
          <p id="subTextMarkedOrders">
            El tipo de interés que aparece en la pantalla de solicitud es orientativo. El tipo de Interés definitivamente aplicable será el
            que figure en la correspondiente liquidación que le efectúe Eurocaja Rural, de acuerdo con lo pactado entre el cliente pagador
            y Eurocaja Rural.<br><br><br>La firma electrónica, implica la cesión de los créditos/facturas cuyo anticipo ha solicitado usted,
            sometida dicha cesión a la expresa aceptación de la Entidad Cesionaria. A su vez usted declara conocer y aceptar tanto las condiciones
            particulares mostradas en las distintas pantallas de solicitud de anticipo, como las condiciones generales del contrato indicadas
            en el pdf siguiente.<br><br><br>
          </p>
          <div @click="downloadPdf" class="downloadPdf">
            <!--<img id="adPayMarkImg" src="../assets/img/pdf-icon.png" alt="Descarga pdf"> -->
            <a id="pdfParticularConditions">S</a>
            <a id="textParticularConditions">Condiciones Particulares EurocajaRuralConfirming</a>
          </div>
          <br/>
          <div class="margenCheckSwitch">
            <md-checkbox :disabled="isDisabledCheck" v-model="condiciones">He leído y aceptado las Condiciones EurocajaRuralConfirming</md-checkbox>
          </div>
          <div class="AdvancePaymentsButtons">
            <!-- Boton aceptar -->
            <input type="submit" class="btnPrimary separacion" @click="aceptar()" value="Aceptar" :disabled="isDisabled" v-if=beforeSubmit>
            <!-- Boton volver -->
            <input class="btnSecondary" type="button" value="Volver" @click="volver">
          </div>
          <div class="firmaconSalida" v-if=datosFirma>
            <SignatureComponent :queries="queries" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import format from 'date-fns/format';
import SignatureComponent from './SignatureComponent';
import download from 'downloadjs';
export default {
    name : 'AdvancePaymentofMarkedOrdersComponent',
    data(){
      return{
        ordenMarcada: new Array(),
        condiciones:false,
        firma:false,
        beforeSubmit:true,
        llamada:null,
        isDisabledCheck:true,
        queries:null,
        mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
        confirmacion:null,
        datosFirma: null,
        datosFirmaSim: null,
        datosSalida:null
      }
    },
    created: function(){ //simulacion previa donde obtenemos datos que se muestran por pantalla
    var ventana=this;
      const baseURI = '/api-confirming/confirming/suppliers/markedorders/advanceSimulate';
            const options = {
                params: {
                    'deudorId':this.$route.params.deudor,
                    'userConditions' : 1
                }
              };
              this.llamada = {
                urlEndpoint : baseURI,
                metodo : 'POST'
              };
              this.queries = options.params;
            let loader = this.$loading.show();
            this.$http.post(baseURI,null,options)
            .then((result) => {
              this.datosSalida=result.data.data; 
              var gastos=this.datosSalida.totalCommission.amount/*+this.datosSalida.totalIva.amount*/;
              var date = new Date(this.datosSalida.date);
              let dateFormat = 'dd/MM/yyyy';
              this.ordenMarcada= [{label: 'Cuenta de abono',value: this.datosSalida.accountConfirming.formats[0].value},
              {label: 'Fecha solicitud de anticipo',value: format(date, dateFormat)},
              {label: 'N\u00B0 facturas a anticipar',value: this.datosSalida.totalOrders},
              {label: 'Importe facturas',value: this.datosSalida.totalAmount.amount,moneda: this.datosSalida.totalAmount.currency ? this.formatearMoneda(this.datosSalida.totalAmount.currency.id) : ''},
              {label: 'Comisión',value: gastos,moneda: this.datosSalida.totalCommission.currency ? this.formatearMoneda(this.datosSalida.totalCommission.currency.id) : ''},
              {label: 'Intereses',value: this.datosSalida.totalInterest.amount,moneda: this.datosSalida.totalInterest.currency ? this.formatearMoneda(this.datosSalida.totalInterest.currency.id) : ''},
              {label: 'IVA Comisión',value: this.datosSalida.totalIva.amount,moneda: this.datosSalida.totalIva.currency ? this.formatearMoneda(this.datosSalida.totalIva.currency.id) : ''},
              {label: 'Importe neto anticipo',value: this.datosSalida.totalNetAmount.amount,moneda: this.datosSalida.totalNetAmount.currency ? this.formatearMoneda(this.datosSalida.totalNetAmount.currency.id) : ''}];
            })
            .catch(function (error) {
              if(error.response){ 
                if(error.response.status == 400) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    ventana.datosFirmaSim = error.response.data.result.errors[0].info;
                  }else{
                    if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                      ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                    }else{ //si no, por defecto
                      ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                    }
                    ventana.confirmacion='KO';
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }else{
                  if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                    ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                  }else{ //si no, por defecto
                    ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                  }
                  ventana.confirmacion='KO';
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                  });
                }
              }
            })
            .then(function () {
              loader.hide();
            });
    },
    components: {
      SignatureComponent
    },
    computed : {
      isDisabled: function() { //aqui pondremos los campos obligatorios de nuestro form
        return  !this.condiciones;
      }
    },
    methods: {
      downloadPdf() {
        const ventana=this;
        var idgdoc='5f4f4407-c7fa-40d1-abbb-f86ad69745ca'; //el de eurocaja PRO por defecto por si la parametrizacion no funciona
        switch(location.origin){
          case 'http://localhost:8080':{ //local
            idgdoc='edc04dff-ea02-425f-908c-a4b1fcba907b';
            break;
          }
          case 'https://10.31.18.15':{ //desa prod
            idgdoc='edc04dff-ea02-425f-908c-a4b1fcba907b';
            break;
          }
          case 'https://10.31.132.5':{ //ec pre
            idgdoc='8cb68438-e344-4459-832c-1e620a2690b2';
            break;
          }
          case 'https://onesaitportal.eurocajarural.es':{ //ec pro
            idgdoc='ea2a95ef-a50b-4108-8dda-9a4ab945d359';
            break;
          }
        }
        const baseURI = '/api-documents/documents/'+idgdoc;
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'GET'
        };     
        let loader = this.$loading.show();
        this.$http.get(baseURI, {responseType: 'blob'})
        .then((result) => {
          const content = result.headers['content-type'];
          if(download(result.data, "CondicionesParticularesRuralConfirming", content)){ //si la descarga va bien
            var blob = new Blob([result.data], { type: 'application/pdf' });
            var url = window.URL.createObjectURL(blob);
            window.open(url); //abrimos el pdf
            this.isDisabledCheck=false; //una vez descargado y abierto el pdf, habilitamos el check de que ha leido de las condiciones
          }
        })
        .catch(error => {
          var codError = null;
          var descError = null;
          if(error.response){ 
            if(error.response.status != 200) {
                if(error.response.data.result) {
                  codError = error.response.data.result.errors[0].errorCode;
                  descError = error.response.data.result.errors[0].errorDescription;
                } else if(error.response.data.error) {
                  codError = error.response.data.error;
                  descError = error.response.data.error_description;
                }else {
                  codError = "400";
                  descError = "No se ha podido descargar el pdf";
                }
                ventana.mensajeError = codError + " - " + descError;
                ventana.confirmacion = "KO";
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
        })
        .then(function () {
          loader.hide();
        });
      },
      formatearMoneda(coin) {
        if(coin=="EUR") {
          coin = "€"
          return coin;
        }else if(coin=="DOL") {
          coin = "$"
          return coin;
        }
      },
      callBackAceptarSim(confirmacion, result){
        if(confirmacion=='KO'){
          this.confirmacion = confirmacion;
          this.mensajeError = result;
        }else if(confirmacion=='OK'){
          this.confirmacion = null;
          this.mensajeError = null;
          this.datosFirmaSim = null;
          this.datosSalida=result.data.data; 
          var date = new Date(this.datosSalida.date);
          let dateFormat = 'dd/MM/yyyy';
          this.ordenMarcada= [{label: 'Cuenta de abono',value: this.datosSalida.accountConfirming.formats[0].value},
          {label: 'Fecha solicitud de anticipo',value: format(date, dateFormat)},
          {label: 'N\u00B0 facturas a anticipar',value: this.datosSalida.totalOrders},
          {label: 'Importe facturas',value: this.datosSalida.totalAmount.amount,moneda: this.datosSalida.totalAmount.currency ? this.formatearMoneda(this.datosSalida.totalAmount.currency.id) : ''},
          {label: 'Comisiones',value: this.datosSalida.totalCommission.amount,moneda: this.datosSalida.totalCommission.currency ? this.formatearMoneda(this.datosSalida.totalCommission.currency.id) : ''},
          {label: 'Intereses',value: this.datosSalida.totalInterest.amount,moneda: this.datosSalida.totalInterest.currency ? this.formatearMoneda(this.datosSalida.totalInterest.currency.id) : ''},
          {label: 'IVA',value: this.datosSalida.totalIva.amount,moneda: this.datosSalida.totalIva.currency ? this.formatearMoneda(this.datosSalida.totalIva.currency.id) : ''},
          {label: 'Importe neto anticipo',value: this.datosSalida.totalNetAmount.amount,moneda: this.datosSalida.totalNetAmount.currency ? this.formatearMoneda(this.datosSalida.totalNetAmount.currency.id) : ''}];
        }
      },
      volver(){
        this.$router.push({ name:'gestionAnticipos', 
          params: { 
            deudor:this.$route.params.deudor, 
            fechaDesde : this.$route.params.fechaDesde, 
            fechaHasta : this.$route.params.fechaHasta, 
            fechaAltaDesde : this.$route.params.fechaAltaDesde, 
            fechaAltaHasta : this.$route.params.fechaAltaHasta,
            importeDesde : this.$route.params.importeDesde, 
            importeHasta : this.$route.params.importeHasta, 
            deudores : this.$route.params.deudores 
          }
        });
      },
     callBackCancelarSim(){
         this.volver();
      },
      callBackAceptar(confirmacion, mensaje){
        if(confirmacion=='OK'){
          this.datosFirma = null;
        }
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.mensajeError = mensaje;
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      },
     callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
      aceptar(){ 
        const ventana=this;
        const baseURI = '/api-confirming/confirming/suppliers/markedorders/advance';
        const options = {
          params: {
            'deudorId':this.$route.params.deudor,
            'userConditions' : 1
          }
        };
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'POST'
        };
        this.queries = {
          'deudorId':this.$route.params.deudor,
          'userConditions' : 1
        };
        let loader = this.$loading.show();
        this.$http.post(baseURI,null,options)
        .then(() => {
          ventana.confirmacion='OK';
          this.beforeSubmit = false;
          window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
        })
        .catch(function (error) {
          if(error.response){ 
            if(error.response.status == 400) {
              if(error.response.data.result.errors[0].errorCode == "096H") {
                ventana.datosFirma = error.response.data.result.errors[0].info;
                ventana.beforeSubmit = false;
              }else{
                if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                  ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                }else{ //si no, por defecto
                  ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                }
                ventana.confirmacion='KO';
                  ventana.beforeSubmit=true;
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
              }
            }else{
              if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
              }else{ //si no, por defecto
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
              }
              ventana.confirmacion='KO';
              ventana.beforeSubmit=true;
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        })
        .then(function () {
          loader.hide();
        });
      }
    }
}
</script>